<script lang="ts">
  import { Button } from "carbon-components-svelte";
  import ArrowDown from "carbon-icons-svelte/lib/ArrowDown.svelte";
  import ArrowDownLeft from "carbon-icons-svelte/lib/ArrowDownLeft.svelte";
  import ArrowDownRight from "carbon-icons-svelte/lib/ArrowDownRight.svelte";
  import ArrowLeft from "carbon-icons-svelte/lib/ArrowLeft.svelte";
  import ArrowRight from "carbon-icons-svelte/lib/ArrowRight.svelte";
  import CenterCircle from "carbon-icons-svelte/lib/CenterCircle.svelte";
  import ArrowUp from "carbon-icons-svelte/lib/ArrowUp.svelte";
  import ArrowUpLeft from "carbon-icons-svelte/lib/ArrowUpLeft.svelte";
  import ArrowUpRight from "carbon-icons-svelte/lib/ArrowUpRight.svelte";

  export let id: string;
  export let positionPreset: string[];
  export let disabled: boolean = false;

  function setPostion(postion) {
    positionPreset = postion;
  }
  // "Top", "Middle", "Bottom", "Left", "Center", "Right"
</script>

<label class="bx--label" for="preset{id}">
  Place image using any of the 9 fixed location
</label>
<div id="preset{id}" class="preset-positioning">
  <Button
    {disabled}
    class="cbtn"
    size="lg"
    kind="secondary"
    iconDescription="Up Left"
    icon={ArrowUpLeft}
    on:click={() => setPostion(["Top", "Left"])}
  />

  <Button
    {disabled}
    class="cbtn"
    size="lg"
    kind="secondary"
    iconDescription="Up"
    icon={ArrowUp}
    on:click={() => setPostion(["Top", "Center"])}
  />

  <Button
    {disabled}
    class="cbtn"
    size="lg"
    kind="secondary"
    iconDescription="Up Right"
    icon={ArrowUpRight}
    on:click={() => setPostion(["Top", "Right"])}
  />

  <Button
    {disabled}
    class="cbtn"
    size="lg"
    kind="secondary"
    iconDescription="Left"
    icon={ArrowLeft}
    on:click={() => setPostion(["Middle", "Left"])}
  />

  <Button
    {disabled}
    class="cbtn"
    size="lg"
    kind="secondary"
    iconDescription="Center"
    icon={CenterCircle}
    on:click={() => setPostion(["Middle", "Center"])}
  />

  <Button
    {disabled}
    class="cbtn"
    size="lg"
    kind="secondary"
    iconDescription="Right"
    icon={ArrowRight}
    on:click={() => setPostion(["Middle", "Right"])}
  />

  <Button
    {disabled}
    class="cbtn"
    size="lg"
    kind="secondary"
    iconDescription="Down Left"
    icon={ArrowDownLeft}
    on:click={() => setPostion(["Bottom", "Left"])}
  />

  <Button
    {disabled}
    class="cbtn"
    size="lg"
    kind="secondary"
    iconDescription="Down"
    icon={ArrowDown}
    on:click={() => setPostion(["Bottom", "Center"])}
  />

  <Button
    {disabled}
    class="cbtn"
    size="lg"
    kind="secondary"
    iconDescription="Down Right"
    icon={ArrowDownRight}
    on:click={() => setPostion(["Bottom", "Right"])}
  />
</div>
